

import { Box, Checkbox, Grid, ImageList, ImageListItem, Pagination, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FC, useEffect, useRef, useState } from 'react';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { IReportingImage } from '../../admin/ReportingImage/types';
import React from 'react';
import { PaginationItemStyle } from './styled';


// const itemData = [
//     {
//         img: reporting_1,
//         width: 432,
//         height: 231,
//         rows: 18
//     },
//     {
//         img: reporting_3,
//         width: 438,
//         height: 315,
//         rows: 24
//     },
//     {
//         img: reporting_5,
//         width: 409,
//         height: 654,
//         rows: 47
//     },
//     {
//         img: reporting_2,
//         width: 432,
//         height: 403,
//         rows: 29
//     },
//     {
//         img: reporting_4,
//         width: 438,
//         height: 320,
//         rows: 22
//     },
//     {
//         img: reporting_5,
//         width: 432,
//         height: 654,
//         rows: 47
//     },
//     {
//         img: reporting_2,
//         width: 438,
//         height: 403,
//         rows: 29
//     },
//     {
//         img: reporting_3,
//         width: 409,
//         height: 315,
//         rows: 24
//     },
//     {
//         img: reporting_4,
//         width: 409,
//         height: 320,
//         rows: 22
//     },
//     {
//         img: reporting_1,
//         width: 438,
//         height: 231,
//         rows: 18
//     },
// ];

const itemData = [
    {
        width: 432,
        height: 231,
        rows: 18,
        widthT: 364,
        heightT: 283,
        rowsT: 21,
        widthP: 350,
        heightP: 272,
        rowsP: 20
    },
    {
        width: 438,
        height: 315,
        rows: 24,
        widthT: 364,
        heightT: 477,
        rowsT: 35,
        widthP: 350,
        heightP: 460,
        rowsP: 34
    },
    {
        width: 409,
        height: 654,
        rows: 47,
        widthT: 364,
        heightT: 179,
        rowsT: 14,
        widthP: 350,
        heightP: 172,
        rowsP: 13
    },
    {
        width: 432,
        height: 403,
        rows: 29,
        widthT: 364,
        heightT: 262,
        rowsT: 20,
        widthP: 350,
        heightP: 252,
        rowsP: 19
    },
    {
        width: 438,
        height: 320,
        rows: 23,
        widthT: 364,
        heightT: 262,
        rowsT: 20,
        widthP: 350,
        heightP: 252,
        rowsP: 19
    },

    {
        width: 432,
        height: 654,
        rows: 47,
        widthT: 364,
        heightT: 477,
        rowsT: 35,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 438,
        height: 403,
        rows: 30,
        widthT: 364,
        heightT: 283,
        rowsT: 21,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 409,
        height: 315,
        rows: 24,
        widthT: 364,
        heightT: 179,
        rowsT: 14,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 409,
        height: 320,
        rows: 23,
        widthT: 364,
        heightT: 262,
        rowsT: 20,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 438,
        height: 231,
        rows: 18,
        widthT: 364,
        heightT: 262,
        rowsT: 20,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    }
];

interface IProps {
    rowsPerPage: number
}

const ReportingBig: FC<IProps> = ({ rowsPerPage }) => {
    const theme = useTheme();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const myRef = useRef<HTMLDivElement>(null)

    const [page, setPage] = useState(1);

    const { SearchReportingImage, DeleteReportingImage } = useActions();
    const { reportingImages, count } = useTypedSelector((store) => store.reportingImage);

    useEffect(() => {
        document.title = `Як відбувається захід?`;
        getData();
    }, [page]);

    const getData = async () => {
        try {
            await SearchReportingImage(page, rowsPerPage);
        } catch (ex) {
        }
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    return (
        <>
            <Grid ref={myRef} item xs={4} md={5} lg={12} sx={{ mt: { xs: "13px", lg: "35px" } }} >
                {(isXl || isLg) && <ImageList
                    variant="quilted"
                    cols={3}
                    rowHeight={10}
                    sx={{ display: { xs: "none", lg: "grid" }, overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <React.Fragment key={`reporting_image_${index}`}>
                            <ImageListItem rows={itemData[index].rows || 1} sx={{ mr: "10px" }}>
                                <img
                                    loading="eager"
                                    src={item.name}
                                    style={{ width: `${itemData[index].width}px`, height: `${itemData[index].height}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                            </ImageListItem>
                            {index === 4 && <ImageListItem key={`reporting_image_m_${index}`} cols={3} />}
                        </React.Fragment>
                    ))}
                </ImageList>}
                {isMd && <ImageList
                    variant="quilted"
                    cols={2}
                    rowHeight={10}
                    sx={{ display: { xs: "none", md: "grid", lg: "none" }, mt: "14px", overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <React.Fragment key={`reporting_image_${index}`}>
                            <ImageListItem rows={itemData[index].rowsT || 1} sx={{ mr: "8px" }}>
                                <img
                                    loading="lazy"
                                    src={item.name}
                                    style={{ width: `${itemData[index].widthT}px`, height: `${itemData[index].heightT}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                            </ImageListItem>
                            {index === 4 && <ImageListItem key={`reporting_image_m_${index}`} cols={2} />}
                        </React.Fragment>
                    ))}
                </ImageList>}
                {isXs && <ImageList
                    variant="quilted"
                    cols={1}
                    rowHeight={10}
                    sx={{ display: { xs: "grid", md: "none" }, mt: "14px", overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <React.Fragment key={`reporting_image_${index}`}>
                            {index < 5 && <ImageListItem rows={itemData[index].rowsP || 1} sx={{ mr: "8px" }}>
                                <img
                                    loading="lazy"
                                    src={item.name}
                                    style={{ width: `${itemData[index].widthP}px`, height: `${itemData[index].heightP}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                            </ImageListItem>}
                        </React.Fragment>
                    ))}
                </ImageList>}
            </Grid>
            {count !== 0 && <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "center", mt: { md: "28px", lg: "35px" } }}>
                <Pagination count={Math.ceil(count / rowsPerPage)} page={page} shape="rounded" size="large"
                    onChange={(event: any, value: number) => {
                        handleChangePage(event, value);
                        if (myRef.current) {
                            myRef.current.scrollIntoView({ behavior: "smooth" });
                        }
                    }}
                    renderItem={(item) => <PaginationItemStyle {...item} />} />
            </Grid>}
        </>
    );
}

export default ReportingBig